
import helper from '../helper';

const _h = ( obj ) => {
    return helper.creatObject( obj );
}

const hayyaBuildMenu = () => {

    const menus = document.querySelectorAll('.wp-block-hayyabuild-menu')

    // if ( menus && window.innerWidth < 992 ) {
        
    //     for ( let i = 0; i < menus.length; i++ ) {
        menus && window.innerWidth < 782 && menus.forEach( menu => {
            // const menu = menus[i];

            const menuMainUL = menu.querySelector('.wp-block-hayyabuild-menu > ul');

            if ( menuMainUL ) {

                const page_item = menuMainUL.querySelectorAll('.page_item_has_children,.menu-item-has-children'),
                      arrow = document.body.classList.contains( 'rtl' ) ? 'left' : 'right',
                      closeList = document.createElement('LI'),
                      closeLink = document.createElement('A'),
                      bodyContainer = document.createElement('DIV'),
                      id = menu.getAttribute('id'),
                      toggleLink = menu.querySelector('.hb-toggle-menu');
                
                _h( bodyContainer ).addClass('hayyabuild-menu-container').setAttr('data-menu-id', id);

                toggleLink && _h( toggleLink ).setAttr('data-menu-id', id);

                for (let j = 0; j < page_item.length; j++) {
                    const el = page_item[j];
                    const icon = document.createElement( 'I' );
                    _h(icon).addClass( 'fa' ).addClass( 'fa-angle-' + arrow );
                    el.append( icon );
                }

                _h( closeLink ).setAttr('href', '#').text( '+' );
                _h( closeList ).addClass('hb-menu-close');//.setAttr('href', '#').text( '+' );

                closeList.append( closeLink );
                menuMainUL.append( closeList );
                bodyContainer.append( menuMainUL );

                // closeLink.addEventListener( 'click', (event) => {
                //     event.preventDefault();
                //     _h( bodyContainer ).removeClass('show-mobile-menu').css({
                //         display: 'none'
                //     });
                // });

                const arrowClick = menuMainUL.querySelectorAll( '.page_item_has_children .fa, .menu-item-has-children .fa' );

                arrowClick && arrowClick.forEach( elem => {
                        elem.addEventListener( 'click', () => {
                            if ( _h( elem.parentNode ).hasClass('open-menu') ) {
                                _h( elem.parentNode ).removeClass('open-menu');
                                _h( elem ).addClass( 'fa-angle-' + arrow ).removeClass( 'fa-angle-down' );
                            } else {
                                _h( elem.parentNode ).addClass('open-menu');
                                _h( elem ).removeClass( 'fa-angle-' + arrow ).addClass( 'fa-angle-down' );
                            }
                        });
                })
                document.body.append( bodyContainer );

                // delete bodyContainer, menuMainUL, id;
            }
        })
    // }
    
    
    const closeContainer = document.body.querySelectorAll('.hayyabuild-menu-container');
    closeContainer && ( () => {
        for (let i = 0; i < closeContainer.length; i++) {
            const el = closeContainer[i];
            el.addEventListener( 'click', (event) => {
                event.target.classList.contains('show-mobile-menu') && _h( el ).removeClass('show-mobile-menu')
            });
        }
    })();

    const closeLink = document.body.querySelectorAll('.hb-menu-close');
    closeLink && closeLink.forEach( el =>{
        el.addEventListener( 'click', (event) => {
            event.preventDefault();
            const bodyContainer = document.body.querySelectorAll('.show-mobile-menu');
            bodyContainer && bodyContainer.forEach( e => {
                e.classList.contains('show-mobile-menu') && _h( e ).removeClass('show-mobile-menu')
            })
        });
    })

    window.addEventListener( 'load', function() {
        const toggleLink = document.body.querySelectorAll('.hb-toggle-menu');
        toggleLink && toggleLink.forEach( toggle => {
            toggle.getAttribute('data-menu-id') && ( () => {
                const menuID = toggle.getAttribute('data-menu-id');
                const menuContainer = document.body.querySelector('.hayyabuild-menu-container[data-menu-id="' + menuID + '"]');
                
                menuContainer && toggle.addEventListener( 'click', (event) => {
                    event.preventDefault();
                    _h( menuContainer ).addClass('show-mobile-menu')
                });
            })();
        })
    });

} // primaryMenu:

export default hayyaBuildMenu;
